import React from 'react';
import styled from "styled-components";
import { keyframes } from "styled-components";
import { css } from "styled-components";
import { FaCoins } from "react-icons/fa";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Wspólne style dla Reels, Lawyer i Facebook
export const ChatbotContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100vh - 104px);
  width: calc(100vw - 200px);
  background-color: ${({ theme }) => theme.color.spotifyBlack};
  overflow: hidden;
  position: fixed;
  top: 104px;
  left: 200px;

  @media (max-width: 1124px) {
    flex-direction: column;
    height: calc(100vh - 104px);
   width: calc(100vw - 70px);
    top: 104px;
     left: 70px;
  }

  @media (max-width: 768px) {
    gap: 10px;
    height: 100vh;
    top: 2px;
    left: 0;
  }
`;

export const ChatbotMain = styled.div`
  flex: 2;
  height: 100%;
  width: 66.66vw;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.color.spotifyBlack};
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
  }

  @media (max-width: 1124px) {
    flex: none;
    width: calc(100vw - 70px);
    left: 70px;
    height: 50vh;
    padding: 15px;
  }

   @media (max-width: 768px) {
    height: ${({ isDetailsExpanded, isDetailsPanelVisible, isAdvertisement }) => 
      isAdvertisement 
        ? (isDetailsExpanded ? "25vh" : "65vh")
        : (isDetailsExpanded ? "20vh" : "60vh")};
    ${({ isDetailsPanelVisible }) => (!isDetailsPanelVisible && `height: 100vh`)};
    padding: 10px;
    padding-bottom: ${({ isDetailsPanelVisible }) =>
      isDetailsPanelVisible ? "0" : "60px"};
  }
`;


export const ChatbotDetailsPanel = styled.div`
  flex: 1;
  height: 100%;
  width: 33.33vw;
  background-color: ${({ theme }) => theme.color.spotifyDarkGrey};
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  border-radius: 4px 0 0 0;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
  }

  @media (max-width: 1124px) {
    flex: 1;
    width: calc(100vw - 70px);
    left: 70px;
    height: 50vh;
    padding: 15px;
    border: 1px solid ${({ theme }) => theme.color.spotifyLightGrey};
    border-bottom: none;
    border-right: none;
  }

  @media (max-width: 768px) {
    height: ${({ isDetailsExpanded }) => (isDetailsExpanded ? "80vh" : "40vh")};
    padding: 60px 10px 10px 10px;
    background-color: ${({ isLawyer, isFacebook, theme }) =>
      isLawyer
        ? theme.color.lawyerDarkerGrey
        : isFacebook
        ? theme.color.spotifyDarkGrey
        : theme.color.spotifyDarkerGrey};
    transition: height 0.3s ease;
    position: relative;
  }
`;

export const ChatbotForm = styled.form`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  ${({ isFacebook, isReels, isAdvertisement }) =>
    isFacebook || isReels || isAdvertisement ? `margin-top: 30px;` : ""}

  ${({ isAdvertisement, isDiet, isArticles }) =>
    (isAdvertisement || isArticles) &&
    `
    flex-direction: column;
    gap: 15px;
    
    /* Kontener dla listy rozwijalnej i przycisku */
    > div:first-child {
      display: flex;
      gap: 10px;
      align-items: stretch;
    }
  `}
  ${({ isDiet }) =>
    isDiet &&
    `
    flex-direction: column;
    gap: 15px;
    
    > div {
      display: flex;
      gap: 10px;
      align-items: stretch;
    }
  `}

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: ${({ theme }) => theme.color.spotifyBlack};
    padding: 10px;
    margin-bottom: 0;
    
    ${({ isAdvertisement, isArticles }) => (isAdvertisement || isArticles) && `
      position: relative;
      top: auto;
      gap: 15px;
      padding: 0;
      margin-top: 80px;
      
      > div:first-child {
        flex-direction: column;
        gap: 8px;
      }
    `}
  }
`;

export const ChatbotInput = styled.input`
  flex: 1;
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.color.spotifyDarkGrey};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  font-size: 14px;
  outline: none;
  transition: background-color 0.2s ease;
  height: 40px; /* Jawnie ustawiamy wysokość */
  line-height: 1; /* Normalizujemy line-height */
  box-sizing: border-box; /* Dla pewności */

  &:focus {
    background-color: ${({ isLawyer, isFacebook, theme }) =>
      isLawyer || isFacebook
        ? theme.color.spotifyLightGrey
        : theme.color.spotifyLightGrey};
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 12px;
    height: 34px;
  }
`;

 const TokenCostDisplay = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
  font-size: 12px;
  color: #FFFFFF; /* Biały kolor dla liczby tokenów */
  font-weight: 500;

  svg {
    margin-right: 5px;
    color: #FFD700; /* Złoty kolor dla ikony monety */
  }
`;

const StyledChatbotButton = styled.button`
  padding: ${({ komentarze }) =>
    komentarze
      ? "12px 20px"
      : "10px 20px"
      };
    background-color: ${({ isLawyer, isFacebook, isAdvertisement, theme }) =>
    isLawyer
      ? theme.color.lawyerLightBlue
      : isFacebook
      ? theme.color.facebookBlue
      : isAdvertisement
      ? "#ff6b35" // Pomarańczowy kolor dla ogłoszeń
      : theme.color.spotifyDarkGreen};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  box-sizing: border-box;
  flex-shrink: 0;
  
  &:hover {
    background-color: ${({ isLawyer, isFacebook, isAdvertisement, theme }) =>
      isLawyer
        ? theme.color.lawyerGold
        : isFacebook
        ? theme.color.facebookBrightBlue
        : isAdvertisement
        ? "#e55a2b"
        : theme.color.spotifyBrightGreen};
  }
  &:disabled {
    background-color: ${({ theme }) => theme.color.spotifyGrey};
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 12px;
    height: 34px;
  }
`;

export const StyledButton = styled.button`
  padding: ${({ komentarze }) =>
    komentarze
      ? "12px 20px"
      : "10px 20px"
      };
    background-color: ${({ isLawyer, isFacebook, isAdvertisement, theme }) =>
    isLawyer
      ? theme.color.lawyerLightBlue
      : isFacebook
      ? theme.color.facebookBlue
      : isAdvertisement
      ? "#ff6b35" // Pomarańczowy kolor dla ogłoszeń
      : theme.color.spotifyDarkGreen};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background-color: ${({ isLawyer, isFacebook, isAdvertisement, theme }) =>
      isLawyer
        ? theme.color.lawyerGold
        : isFacebook
        ? theme.color.facebookBrightBlue
        : isAdvertisement
        ? "#e55a2b"
        : theme.color.spotifyBrightGreen};
  }
  &:disabled {
    background-color: ${({ theme }) => theme.color.spotifyGrey};
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 12px;
  }
`;

export const ChatbotButton = ({ children, tokenCost, ...props }) => {
  return (
    <StyledChatbotButton {...props}>
      {children}
      {tokenCost > 0 && (
        <TokenCostDisplay>
          <FaCoins /> {tokenCost}
        </TokenCostDisplay>
      )}
    </StyledChatbotButton>
  );
};

export const ChatbotExpandButton = styled.button`
  display: none;
  padding: 8px 16px;
  background-color: ${({ isLawyer, isFacebook, theme }) =>
    isLawyer
      ? theme.color.lawyerLightGrey
      : isFacebook
      ? theme.color.facebookLightBlue
      : theme.color.spotifyLightGrey};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-bottom: 10px;

  &:hover {
    background-color: ${({ isLawyer, isFacebook, theme }) =>
      isLawyer
        ? theme.color.lawyerGrey
        : isFacebook
        ? theme.color.facebookDarkGrey
        : theme.color.spotifyGrey};
  }

  @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: ${({ isDetailsExpanded }) =>
      isDetailsExpanded ? "calc(20vh + 20px)" : "calc(60vh + 20px)"};
    left: 10px;
    z-index: 10;
  }
`;

export const ChatbotDetailsHeader = styled.div`
  display: none;
  position: fixed;
  top: 60vh;
  left: 0;
  right: 0;
  height: 60px;
  background-color: ${({ isLawyer, isFacebook, theme }) =>
    isLawyer
      ? theme.color.spotifyDarkerGrey
      : isFacebook
      ? theme.color.spotifyDarkerGrey
      : theme.color.spotifyDarkerGrey};
  z-index: 9;

  &:after {
    content: "";
    position: absolute;
    top: 10px;
    left: 0;
    right: 0;
    height: 1px;
    background-color: ${({ isLawyer, isFacebook, theme }) =>
      isLawyer
        ? theme.color.lawyerLightGrey
        : isFacebook
        ? theme.color.facebookLightBlue
        : theme.color.spotifyLightGrey};
  }

  @media (max-width: 768px) {
    display: block;
    top: ${({ isDetailsExpanded }) => (isDetailsExpanded ? "19.8vh" : "60vh")};
  }
`;

export const ChatbotLoading = styled.div`
  margin-top: 20px;
  color: ${({ isLawyer, isFacebook, theme }) =>
    isLawyer
      ? theme.color.lawyerGold
      : isFacebook
      ? theme.color.facebookBlue
      : theme.color.spotifyDarkGreen};
  font-size: 16px;
  font-weight: 700;

  @media (max-width: 768px) {
    margin-top: 80px;
    font-size: 14px;
  }
`;

export const ChatbotError = styled.div`
  margin-top: 20px;
  ${({ isLawyer }) => isLawyer && `margin-top: 0px;`}
  ${({ isLawyerDetails }) => isLawyerDetails && `margin-top: 0px;`}
  color: #ff4d4d;
  font-size: 16px;

   @media (max-width: 768px) {
    ${({ isLawyer }) => isLawyer && `margin-top: 30px;`}
    ${({ isReels, isFacebook, isAdvertisement }) => 
      (isReels || isFacebook || isAdvertisement) && `margin-top: 160px;`}
    ${({ isLawyerDetails }) => isLawyerDetails && `margin-top: 0px;`}
    font-size: 14px;
  }
`;

export const ChatbotMessage = styled.div`
  margin-top: 20px;
  font-size: 16px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  background-color: ${({ isLawyer, isFacebook, isAdvertisement, theme }) =>
    isLawyer
      ? theme.color.lawyerDarkGrey
      : isFacebook
      ? theme.color.facebookDarkGrey
      : isAdvertisement
      ? theme.color.spotifyDarkerGrey
      : theme.color.spotifyDarkGrey};
  padding: 15px;
  border-radius: 4px;
  white-space: pre-line;

  @media (max-width: 768px) {
    margin-top: 12px;
    ${({ isSuggestions, isAdvertisement }) => 
      (isSuggestions || isAdvertisement) && `margin-top: 160px;`}
    font-size: 14px;
  }
      img {
   max-width: 100%;
   max-height: 80vh;   
    object-fit: contain;
  display: block;
    margin: 0 auto;
  }
`;

export const ChatbotMessageDescription = styled.div`
 margin-top: ${({ isDescription }) =>
    (isDescription ? "-10px" : "20px")};
   font-size: ${({ isDescription }) =>
    (isDescription ? "13px" : "16px")};
  color: ${({ isDescription, theme }) =>
    isDescription ? theme.color.spotifyGrey || "#1e90ff" : theme.color.imageWhite || "#1e90ff"};
  background-color: ${({ theme }) => theme.color.facebookDarkGrey || "#1a1a1a"};
  padding: 15px;
  border-radius: 4px;
  white-space: pre-line;

  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 14px;
  }
`;

export const ChatbotDetails = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  line-height: 1.5;
  white-space: pre-line;

  ${({ isDiet }) =>
    isDiet
      ? css`
          p {
            margin-bottom: 1em;
          }
          ul,
          ol {
            padding-left: 20px;
            margin-bottom: 1em;
          }
          li {
            margin-bottom: 0.5em;
          }
        `
      : css`
          p {
            margin-bottom: 8px;
            padding: 6px 8px;
            background-color: transparent;
            border-radius: 4px;
            transition: background-color 0.2s ease;
          }
        `}

  h2 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 15px;
    color: ${({ isFacebook, isAdvertisement, theme }) =>
      isFacebook 
        ? theme.color.facebookBlue 
        : isAdvertisement
        ? "#ff6b35"
        : theme.color.spotifyBrightGreen};
    border-bottom: 1px solid ${({ theme }) => theme.color.spotifyLightGrey};
    padding-bottom: 5px;
  }


  /* Styling for list-like items */
  p:where(:matches(:where(:matches(:where(:starts-with("1. "), :starts-with("2. "), :starts-with("3. "), :starts-with("4. "), :starts-with("5. "), :starts-with("6. "), :starts-with("7. "), :starts-with("8. "), :starts-with("9. "), :starts-with("10. "))), :starts-with("- "), :starts-with("* "), :starts-with("• "))) {
    position: relative;
    padding-left: 30px;
    font-weight: 500;
    color: ${({ theme }) => theme.color.spotifyWhite};

    &:before {
      content: "•";
      position: absolute;
      left: 10px;
      top: 12px;
      color: ${({ isFacebook, theme }) =>
        isFacebook ? theme.color.facebookBlue : theme.color.spotifyDarkGreen};
      font-size: 16px;
    }

    span.emphasis {
      font-weight: 700;
      color: ${({ isFacebook, theme }) =>
        isFacebook ? theme.color.facebookBlue : theme.color.spotifyBrightGreen};
    }
  }

  /* Styling for subheadings (e.g., 1. Dlaczego warto podjąć wyzwanie?) */
  p.subheading {
    font-weight: 700;
    color: ${({ isFacebook, theme }) =>
      isFacebook ? theme.color.facebookBlue : theme.color.spotifyBrightGreen};
    background-color: ${({ isFacebook, theme }) =>
      isFacebook ? theme.color.spotifyDarkerGrey : theme.color.spotifyDarkerGrey};
    padding-left: 20px;
  }

  /* Styling for inspirations (e.g., - Anna (34 lata)) */
  p.inspiration {
    font-weight: 600;
    color: ${({ isFacebook, theme }) =>
      isFacebook ? theme.color.facebookLightBlue : theme.color.spotifyLightGreen};
    padding-left: 40px;
    position: relative;

    &:before {
      content: "➜";
      position: absolute;
      left: 20px;
      top: 12px;
      color: ${({ isFacebook, theme }) =>
        isFacebook ? theme.color.facebookBlue : theme.color.spotifyDarkGreen};
      font-size: 14px;
    }
  }

  /* Ograniczenie linii oddzielających do konkretnych przypadków */
  p + p:where(:matches(:where(:matches(:where(:starts-with("1. "), :starts-with("2. "), :starts-with("3. "), :starts-with("4. "), :starts-with("5. "), :starts-with("6. "), :starts-with("7. "), :starts-with("8. "), :starts-with("9. "), :starts-with("10. "))), :starts-with("- "), :starts-with("* "), :starts-with("• "))) {
    border-top: 1px solid ${({ theme }) => theme.color.spotifyLightGrey};
    margin-top: 10px;
    padding-top: 10px;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    ${({ isReels, isFacebook, isAdvertisement }) => 
      (isReels || isFacebook || isAdvertisement) && `margin-bottom: 70px;`}
    h2 {
      font-size: 16px;
      margin-bottom: 12px;
    }

    p {
      margin-bottom: 12px;
      padding: 8px;
    }

    p:where(:matches(:where(:matches(:where(:starts-with("1. "), :starts-with("2. "), :starts-with("3. "), :starts-with("4. "), :starts-with("5. "), :starts-with("6. "), :starts-with("7. "), :starts-with("8. "), :starts-with("9. "), :starts-with("10. "))), :starts-with("- "), :starts-with("* "), :starts-with("• "))) {
      padding-left: 25px;

      &:before {
        top: 10px;
        font-size: 14px;
      }

      span.emphasis {
        font-weight: 600;
      }
    }

    p.subheading {
      padding-left: 15px;
    }

    p.inspiration {
      padding-left: 35px;
      &:before {
        left: 15px;
        top: 10px;
        font-size: 12px;
      }
    }

    p + p:where(:matches(:where(:matches(:where(:starts-with("1. "), :starts-with("2. "), :starts-with("3. "), :starts-with("4. "), :starts-with("5. "), :starts-with("6. "), :starts-with("7. "), :starts-with("8. "), :starts-with("9. "), :starts-with("10. "))), :starts-with("- "), :starts-with("* "), :starts-with("• "))) {
      margin-top: 8px;
      padding-top: 8px;
    }
  }
`;

export const ChatbotSuggestions = styled.div`
  margin-top: 20px;

  @media (max-width: 768px) {
    margin-top: 155px;
  }
`;

export const ChatbotTextarea = styled.textarea`
  width: 100%;
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.color.spotifyDarkGrey};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  font-size: 14px;
  outline: none;
  transition: background-color 0.2s ease;
  margin-top: 10px;
  min-height: 100px;
  resize: vertical;

  &:focus {
    background-color: ${({ theme }) => theme.color.spotifyLightGrey};
  }

  ${({ isAdvertisement, isArticles }) => (isAdvertisement || isArticles) && `
    min-height: 120px;
    font-family: inherit;
    line-height: 1.4;
  `}
  
  @media (max-width: 768px) {
    height: auto;
    resize: none;
    overflow: hidden;
    padding: 8px 12px;
    font-size: 12px;
    min-height: 80px;
    
    ${({ isAdvertisement, isArticles }) => (isAdvertisement || isArticles) && `
      min-height: 100px;
      resize: vertical;
    `}
  }
`;

export const AppTitle = styled.h1`
  color: ${({ theme }) => theme.color.tileTitle};
  font-size: 24px;
  margin-bottom: 25px;
  text-align: center;
  @media (min-width: 768px) {
    margin-top: 0px;
  }
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    margin: 0;
    background-color: ${({ theme }) => theme.color.spotifyBlack};
    z-index: 11;
  }
`;

export const DocumentTypeSelector = styled.select`
  flex: 1;
  min-width: 0;
  padding: 10px 30px 10px 15px;
  background-color: ${({ isAdvertisement, theme }) =>
    isAdvertisement 
      ? theme.color.spotifyDarkerGrey 
      : theme.color.spotifyDarkGrey};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  font-size: 14px;
  outline: none;
  transition: background-color 0.2s ease;
  height: 40px;
  line-height: 1;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  position: relative;
  cursor: pointer;

  &:focus {
    background-color: ${({ isLawyer, isFacebook, isAdvertisement, theme }) =>
      isLawyer || isFacebook || isAdvertisement
        ? theme.color.spotifyLightGrey
        : theme.color.spotifyLightGrey};
  }

  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23FFFFFF' stroke-width='2'><polyline points='6 9 12 15 18 9'></polyline></svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;

  @media (max-width: 768px) {
    padding: 8px 25px 8px 12px;
    font-size: 12px;
    height: 34px;
    background-position: right 8px center;
    background-size: 14px;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-color: ${({ theme }) => theme.color.lawyerLightGrey};
  }

  @media (max-width: 768px) {
    margin-top: 150px;
  }
`;

export const Tab = styled.button`
  transition: background-color 0.2s ease;
  padding: 10px 20px;
  background-color: ${({ active, isLawyer, isFacebook, theme }) =>
    active
      ? isLawyer
        ? theme.color.lawyerLightBlue
        : isFacebook
        ? theme.color.facebookBlue
        : theme.color.spotifyDarkGreen
      : "transparent"};
  color: ${({ theme }) => theme.color.spotifyWhite};
  border: none;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  font-size: 14px;
  font-weight: ${({ active }) => (active ? "700" : "400")};
  will-change: background-color;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};

  &:hover {
    background-color: ${({ disabled, isLawyer, isFacebook, theme }) =>
      disabled
        ? "transparent"
        : isLawyer
        ? theme.color.lawyerGold
        : isFacebook
        ? theme.color.facebookBrightBlue
        : theme.color.spotifyBrightGreen};
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 12px;
  }
`;

export const CopyButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;

  @media (max-width: 768px) {
   align-items: center;
  justify-content: center;
    margin-bottom: 70px;
  }
`;

export const CopyButton = styled.button`
  padding: 10px 20px;
  background-color: ${({ isLawyer, isFacebook, theme }) =>
    isLawyer
      ? theme.color.lawyerLightBlue
      : isFacebook
      ? theme.color.facebookBlue
      : theme.color.spotifyDarkGreen};
  border: none;
  border-radius: 4px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: ${({isUnderImage}) =>
    (isUnderImage
      ? "20vh"
      : "50%" )};
  box-sizing: border-box;

  &:hover {
    background-color: ${({ isLawyer, isFacebook, theme }) =>
      isLawyer
        ? theme.color.lawyerGold
        : isFacebook
        ? theme.color.facebookBrightBlue
        : theme.color.spotifyBrightGreen};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.color.spotifyGrey};
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 12px;
     width: 50%;
  }
`;

export const SuggestionsHeader = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.color.spotifyWhite};
  margin-bottom: 15px;
`;

export const SuggestionsBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SuggestionItemContainer = styled.div`
  background-color: ${({ theme }) => theme.color.spotifyDarkGrey};
  padding: 15px;
  border-radius: 4px;
  cursor: ${({ isHistory }) => (isHistory ? "text" : "pointer")};
  transition: background-color 0.2s ease;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;

  &:hover {
    background-color: ${({ theme }) => theme.color.spotifyLightGrey};
  }
`;

const SuggestionContentWrapper = styled.div`
  flex: 1;
`;

const SuggestionTokenCost = styled(TokenCostDisplay)`
  font-size: 11px;
  flex-shrink: 0;
  white-space: nowrap;
`;

export const SuggestionItem = ({ children, tokenCost, ...props }) => {
  return (
    <SuggestionItemContainer {...props}>
      <SuggestionContentWrapper>
        {children}
      </SuggestionContentWrapper>
      {tokenCost > 0 && (
        <SuggestionTokenCost>
          <FaCoins /> {tokenCost}
        </SuggestionTokenCost>
      )}
    </SuggestionItemContainer>
  );
};

export const SuggestionTitle = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  margin-bottom: 5px;

  @media (max-width: 1024px) {
    font-size: 14px;
  }
`;

export const SuggestionDescription = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.color.spotifyGrey};

  @media (max-width: 1024px) {
    font-size: 12px;
  }
`;

export const SuggestionLink = styled.a`
  display: inline-block;
  margin-top: 8px;
   color: ${({ theme }) => theme.color.linkBorder};
  font-size: 14px;
  text-decoration: none;
  word-break: break-all;

  &:hover {
    text-decoration: underline;
  }
  
  &:visited {
    color: #8a2be2; /* Fioletowy kolor dla odwiedzonych linków */
  }
`;

export const LoadingElement = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  color: #666;

  &::after {
    content: "";
    width: 16px;
    height: 16px;
    border: 2px solid #666;
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: spin-loading 1s linear infinite;
  }

  @keyframes spin-loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 768px) {
    ${({ isReels, isFacebook }) => (isReels || isFacebook) && `margin-top: 145px;`}
  }
`;

export const ChatbotSection = styled.div`
  margin-bottom: 40px;
`;

export const ChatbotSectionTitle = styled.h2`
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 500;
`;

export const HistoryTile = styled.div`
  background-color: ${({ theme }) => theme.color.spotifyDarkGrey};
  padding: 20px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  &:hover {
    background-color: ${({ theme }) => theme.color.spotifyLightGrey};
    transform: translateY(-2px);
  }
`;

export const HistorySection = styled(ChatbotSection)`
  margin-bottom: 20px;
`;

export const HistorySectionTitle = styled(ChatbotSectionTitle)`
  font-size: 18px;
  color: ${({ theme }) => theme.color.spotifyWhite};
`;

export const HistoryTileWrapper = styled(HistoryTile)`
  &:hover {
    background-color: ${({ theme }) => theme.color.spotifyLightGrey};
  }
`;

export const EntryDetailsContainer = styled.div`
  padding: 20px;
  color: ${({ theme }) => theme.color.spotifyWhite};
  animation: ${fadeIn} 0.5s ease-out forwards;
`;

export const EntryDetailsTitle = styled(SuggestionsHeader)`
  font-size: 20px;
  margin-bottom: 15px;
`;

export const ChatbotHistoryDetailsPanel = styled(ChatbotDetailsPanel)`
  flex: 2;
`;

export const ChatbotName = styled.span`
  font-weight: 700;
  margin-left: 8px;
  color: ${({ isLawyer, isCasual, isFacebook, isImage, isSocialMedia, isSearchEngine, isAdvertisement, isArticles, theme }) =>
    isLawyer
      ? theme.color.lawyerGold
      : isCasual
      ? theme.color.whisper
      : isFacebook
      ? theme.color.facebookBlue
        : isSocialMedia
      ? "#FFCCDD"
       : isImage
      ? "#ffdb4d"
      : isSearchEngine
      ? "#8a2be2" // Fioletowy
      : isAdvertisement
      ? "#ff6b35" // Pomarańczowy
      : isArticles
      ? "#4a90e2" // Niebieski
      : "#1db954"};
`;

export const NumberInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
`;

export const UnitLabel = styled.span`
  position: absolute;
  right: 12px; /* Pozycjonuje po lewej stronie strzałek */
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.color.spotifyGrey};
  font-size: 14px;
  font-weight: 500;
  pointer-events: none;
  z-index: 1;
  
  @media (max-width: 768px) {
    right: 35px;
    font-size: 12px;
  }
`;

export const ChatbotNumberInput = styled(ChatbotInput)`
  padding-right: 38px; /* Dodaje przestrzeń dla etykiety jednostki */
  
  @media (max-width: 768px) {
    padding-right: 60px;
  }
`;

export const HistoryHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 15px;
  
  h1 {
    margin-bottom: 0;
    text-align: left;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    
    h1 {
      text-align: center;
    }
  }
`;

export const HistoryActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const SelectAllButton = styled.button`
  background-color: ${({ theme }) => theme.color.spotifyDarkGrey};
  color: ${({ theme }) => theme.color.spotifyWhite};
  border: 1px solid ${({ theme }) => theme.color.spotifyGrey};
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
  height: 38px;
  line-height: 1.5;
  display: flex;
  align-items: center;
  
  &:hover {
    background-color: ${({ theme }) => theme.color.spotifyLightGrey};
  }
  
  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px 12px;
    height: 32px;
  }
`;

export const DeleteButton = styled.button`
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s ease;
  box-sizing: border-box;
  height: 38px;
  line-height: 1.5;
  
  &:hover {
    background-color: #c82333;
  }
  
  &:disabled {
    background-color: #666;
    cursor: not-allowed;
  }
  
  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px 12px;
    height: 32px;
  }
`;

export const HistoryTileCheckbox = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 12px;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
`;

export const HistoryTileContent = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
`;

export const CategorySelect = styled.select`
  background-color: ${({ theme }) => theme.color.spotifyDarkGrey};
  color: ${({ theme }) => theme.color.spotifyWhite};
  border: 1px solid ${({ theme }) => theme.color.spotifyGrey};
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
  outline: none;
  box-sizing: border-box;
  height: 38px; /* Wysokość taka sama jak przyciski (8px padding top + 8px padding bottom + ~22px line-height) */
  line-height: 1.5;
  
  &:hover {
    background-color: ${({ theme }) => theme.color.spotifyLightGrey};
  }
  
  &:focus {
    border-color: ${({ theme }) => theme.color.spotifyWhite};
  }
  
  option {
    background-color: ${({ theme }) => theme.color.spotifyDarkGrey};
    color: ${({ theme }) => theme.color.spotifyWhite};
  }
  
  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px 12px;
    height: 32px; /* Wysokość taka sama jak przyciski na mobile (6px padding top + 6px padding bottom + ~20px line-height) */
  }
`;